import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import clsx from 'clsx';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';

import { useInsight } from '../../../hooks';
import { subscriber_directories_path } from '../../../routes';
import styles from './styles.module.scss';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const InsightSection = ({
  title,
  entitySource,
  entitySourceAttribute,
  icon,
  searchAttribute,
  expand = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(expand);
  const limit = isExpanded ? 20 : 5;
  const { insight, isLoadingInsight } = useInsight({
    entitySource: entitySource,
    entitySourceAttribute: entitySourceAttribute,
    limit: limit,
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => {
            return value + '%';
          },
        },
      },
    },
    maxBarThickness: 10,
  };

  const labels = [...Array(limit)].map((_, i) => {
    return i + 1;
  });
  const bgColors = isExpanded
    ? [
        '#EC635E',
        '#C63165',
        '#941D6B',
        '#590D6A',
        '#00005E',
        '#232784',
        '#404DAB',
        '#5D74D1',
        '#7C9EF8',
        '#896EBF',
        '#EC635E',
        '#C63165',
        '#941D6B',
        '#590D6A',
        '#00005E',
        '#232784',
        '#404DAB',
        '#5D74D1',
        '#7C9EF8',
        '#896EBF',
      ]
    : 'black';

  const data = {
    labels,
    datasets: [
      {
        label: title,
        data: isLoadingInsight
          ? []
          : insight.top_results.map((result) =>
              ((result[1] / insight.total_count) * 100).toFixed(2)
            ),
        backgroundColor: bgColors,
      },
    ],
  };

  return (
    <Col className={isExpanded ? 'col-md-12' : 'col-md-6'}>
      <div
        className={clsx(
          styles.insightContainer,
          isExpanded ? styles.insightContainerExpanded : styles.insightContainerMin
        )}
      >
        <h3 className={styles.headerTextContainer}>
          <span className={styles.headerTextSpan}>
            <img src={icon} className={styles.titleIcon} />
            <span className={styles.headerText}>{title}</span>
          </span>
          <span className={styles.headerTextBtnContainer}>
            {isExpanded ? '< ' : ''}
            <button className={styles.headerTextBtn} onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? 'Fewer Results' : 'More Results'}
            </button>
            {isExpanded ? '' : ' >'}
          </span>
        </h3>
        {isLoadingInsight ? (
          <div>Loading...</div>
        ) : (
          <Row>
            <Col className={isExpanded ? 'col-md-6' : 'col-md-12'}>
              <ol className={styles.rankedList}>
                {insight.top_results.map((result, i) => (
                  <li key={result[0]} className={styles.rankedListItem}>
                    <a href={subscriber_directories_path({ [searchAttribute]: result[0] })}>
                      <span>
                        {i + 1}. {result[0]}
                      </span>
                    </a>
                    <span className={styles.rankedListItemDetails}>
                      {isExpanded ? (
                        <span
                          className={styles.rankedListItemColorIndicator}
                          style={{ backgroundColor: bgColors[i] }}
                        />
                      ) : (
                        <span />
                      )}

                      <span>{((result[1] / insight.total_count) * 100).toFixed(0)}%</span>
                    </span>
                  </li>
                ))}
              </ol>
            </Col>
            <Col className={isExpanded ? 'col-md-6' : 'col-md-12'}>
              <Bar options={options} data={data} />
            </Col>
          </Row>
        )}
      </div>
    </Col>
  );
};

export default InsightSection;
